var map = {
	"./gift1.png": "1647",
	"./gift10.png": "ec45",
	"./gift11.png": "632d",
	"./gift12.png": "a4d7",
	"./gift13.png": "9f85",
	"./gift14.png": "4ee8",
	"./gift15.png": "6f0c",
	"./gift16.png": "f2a4",
	"./gift17.png": "bd94",
	"./gift18.png": "d2f6",
	"./gift19.png": "73cd",
	"./gift2.png": "f582",
	"./gift20.png": "deb7",
	"./gift21.png": "cd3c",
	"./gift3.png": "fa4e",
	"./gift4.png": "01c2",
	"./gift5.png": "4381",
	"./gift6.png": "cb6a",
	"./gift7.png": "a717",
	"./gift8.png": "7da4",
	"./gift9.png": "ed38",
	"./good0.png": "0058",
	"./good1.png": "226d",
	"./good2.png": "5225",
	"./good22.png": "e1dc",
	"./good3.png": "5ab0",
	"./good4.png": "bae9",
	"./good5.png": "80c7",
	"./good6.png": "a4f0",
	"./good7.png": "84ce",
	"./goods.png": "f6d4",
	"./goodsclose1.png": "eb16",
	"./goodsclose2.png": "c8a1",
	"./goodsclose3.png": "f270",
	"./goodsrope1.png": "005e",
	"./goodsrope2.png": "2a8c",
	"./goodsrope3.png": "df27",
	"./goodsrwdclose.png": "6b60",
	"./main.png": "3b7b",
	"./rope.png": "b6e1",
	"./santa.png": "2244",
	"./simple.png": "9b35",
	"./time.png": "5ebb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a9b";